import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "row mb-2" }
const _hoisted_10 = { class: "col-md-9" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "row mb-2" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row mb-2" }
const _hoisted_15 = { class: "col-md-9" }
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "row mb-2" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = {
  for: "cidadeId",
  class: "form-label obrigatorio"
}
const _hoisted_21 = { class: "col-md-9" }
const _hoisted_22 = { class: "row mb-2" }
const _hoisted_23 = { class: "col-md-9" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "row mb-2" }
const _hoisted_26 = { class: "col-md-9" }
const _hoisted_27 = { class: "row mb-2" }
const _hoisted_28 = { class: "col-md-9" }
const _hoisted_29 = { class: "row mb-2" }
const _hoisted_30 = { class: "col-md-9" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "row mb-2" }
const _hoisted_33 = { class: "col-md-9" }
const _hoisted_34 = { class: "card-footer" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-2" }
const _hoisted_37 = { class: "col-md-8" }
const _hoisted_38 = {
  key: 0,
  class: "fw-bold"
}
const _hoisted_39 = {
  key: 1,
  class: "fw-bold text-danger"
}
const _hoisted_40 = { class: "col-md-2" }

import { defineComponent, onMounted, reactive } from "vue";
import { useRoute } from 'vue-router';

//servicos
import config from "@/app.config.json";
import * as usuarioService from "@/services/usuariosService";
import * as funcoes from "@/utils/funcoes";

//componentes
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import TextBox from "@/components/TextBox/Index.vue";
import UploadFoto from "@/components/UploadFoto/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import AutoCompleteCidade from "@/components/AutoCompletes/AutoCompleteCidade.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import UsuarioCidades from "./UsuarioCidades.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'UsuarioCadastro',
  setup(__props) {


//vue
const route = useRoute();

  var controle = reactive({

    model: {
      nomeCompleto: "",
      ativo: true,
      tipoId: 4,
      
    } as usuarioService.Usuario,
    foto: null as File | null,
    tipos: [] as { texto: string; valor: number }[],
    simNao: [
      { texto: 'SIM', valor: true }, 
      { texto: 'NÃO', valor: false }] as { texto: string; valor: boolean }[],

      erro: "",
      status: ""
  })

  onMounted(() => {

    console.log("buscando usuario id:", route.params.id);

    usuarioService.obterTipos().then((r) => {
      controle.tipos = r.map(a=> {
        return { texto: a.descricao, valor: a.tipoId }
      });
    });

    console.log("buscando usuario id:", route.params.id);

    if (route.params.id) {
      // Se houver um ID na rota, buscar os detalhes do usuário
      usuarioService.obterPorId(Number(route.params.id))
        .then(usuario => {
          controle.model = usuario;
        })
        .catch(error => {
          controle.erro = `Erro ao carregar usuário: ${error}`;
        });
    }

   funcoes.setaFocus("nomeCompleto");


  });

  async function salvar() {
    try {
      // 1. Salvar o registro primeiro
      controle.status = "Salvando...";
      controle.erro = "";
      const resultado = await usuarioService.salvar(controle.model)
      
      // 4. Fazer upload das fotos se existirem
      if (controle.foto?.size > 0) {

          const arquivo = controle.foto as File
          try {
            controle.status = "Salvando foto...";
            console.log(`Salvando foto...`)
            const urlImagem = await usuarioService.uploadFoto(resultado.usuarioId, arquivo)
            console.log(`Salvando foto concluído:`, urlImagem)
            
          } catch (uploadError) {
            controle.erro = `Erro ao salvar foto: ${uploadError}...`;
          }

      }
      
    } catch (error) {
      controle.erro = `Erro ao salvar: ${error}...`;
      return;
    }
    }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Cadastro de Usuário",
      items: [ 
    { label: 'Usuários', to: '/usuarios' }, 
    { label: 'Cadastro', to: '/usuarios/cadastro' } ]
    }),
    _createVNode(Notificacao, {
      erro: _unref(controle).erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (_unref(controle).erro='')),
      progresso: _unref(controle).status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (_unref(controle).status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "usuarioId",
                      class: "form-label"
                    }, "ID")
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.usuarioId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).model.usuarioId) = $event)),
                      id: "usuarioId",
                      formato: 'Numero'
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "nomeCompleto",
                      class: "form-label obrigatorio"
                    }, "Nome")
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.nomeCompleto,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).model.nomeCompleto) = $event)),
                      id: "nomeCompleto"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "tipoId",
                      class: "form-label obrigatorio"
                    }, "Tipo")
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).model.tipoId) = $event)),
                      id: "tipoId",
                      class: "form-select form-select-sm"
                    }, [
                      _cache[17] || (_cache[17] = _createElementVNode("option", { value: null }, "- Selecione -", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).tipos, (tipo) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: tipo.valor,
                          value: tipo.valor
                        }, _toDisplayString(tipo.texto), 9, _hoisted_11))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(controle).model.tipoId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "telefone",
                      class: "form-label"
                    }, "Telefone")
                  ], -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.telefone,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(controle).model.telefone) = $event)),
                      id: "telefone",
                      formato: 'Telefone'
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "email",
                      class: "form-label obrigatorio"
                    }, "Email")
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.email,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(controle).model.email) = $event)),
                      id: "email",
                      formato: 'email'
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "cpf",
                      class: "form-label"
                    }, "CPF")
                  ], -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.cpfCnpj,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(controle).model.cpfCnpj) = $event)),
                      id: "cpfCnpj",
                      formato: 'CpfCnpj'
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, "Cidade " + _toDisplayString(_unref(controle).model.cidadeId), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(AutoCompleteCidade, {
                      modelValue: _unref(controle).model.cidadeId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(controle).model.cidadeId) = $event)),
                      id: "cidadeId"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "observacoes",
                      class: "form-label"
                    }, "Observações")
                  ], -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.observacoes,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(controle).model.observacoes) = $event)),
                      id: "observacoes",
                      formato: 'Texto'
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "referenciaId",
                      class: "form-label"
                    }, "Referência")
                  ], -1)),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.referenciaId,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(controle).model.referenciaId) = $event)),
                      id: "referenciaId",
                      formato: 'Texto',
                      readonly: "readonly"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "senha",
                      class: "form-label obrigatorio"
                    }, "Senha")
                  ], -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(TextBox, {
                      modelValue: _unref(controle).model.senha,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(controle).model.senha) = $event)),
                      id: "senha",
                      type: "password"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "ativo",
                      class: "form-label"
                    }, "Ativo")
                  ], -1)),
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(controle).model.ativo) = $event)),
                      id: "ativo",
                      class: "form-select form-select-sm"
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("option", { value: null }, "- Selecione -", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).simNao, (tipo) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: String(tipo.valor),
                          value: tipo.valor
                        }, _toDisplayString(tipo.texto), 9, _hoisted_31))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _unref(controle).model.ativo]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-md-3" }, [
                    _createElementVNode("label", {
                      for: "foto",
                      class: "form-label"
                    }, "Foto")
                  ], -1)),
                  _createElementVNode("div", _hoisted_33, [
                    _createTextVNode(_toDisplayString(`${_unref(config).urlApi}/Fotos/Usuarios/${_unref(controle).model.usuarioId}.png`) + " ", 1),
                    _createVNode(UploadFoto, {
                      modelValue: _unref(controle).foto,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(controle).foto) = $event)),
                      id: "foto",
                      accept: 'image/*',
                      alt: 'Foto de Perfil',
                      imageUrl: `${_unref(config).urlApi}/Fotos/Usuarios/${_unref(controle).model.usuarioId}.png`
                    }, null, 8, ["modelValue", "imageUrl"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("a", {
                  class: "btn btn-sm btn-primary",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (salvar()))
                }, "Salvar")
              ]),
              _createElementVNode("div", _hoisted_37, [
                (_unref(controle).erro == null && _unref(controle).status != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_unref(controle).status), 1))
                  : _createCommentVNode("", true),
                (_unref(controle).erro != null )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(controle).erro), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_RouterLink, {
                  class: "btn btn-sm btn-secondary float-end",
                  to: '/usuarios'
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createTextVNode("Fechar", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_unref(controle).model.usuarioId > 0)
      ? (_openBlock(), _createBlock(UsuarioCidades, {
          key: 0,
          UsuarioId: _unref(controle).model.usuarioId
        }, null, 8, ["UsuarioId"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})